<div class="component-container" >
 <a href="#" target="_blank" >link</a>
</div>
